const ACCOUNT_ANIMAL_TRAIL_ROUTE = /^\/trails\/([0-9a-f-]+)\/?$/i;

export function accountAnimalTrailIdFromRoute(pathname: string): string | null {
  return pathname.match(ACCOUNT_ANIMAL_TRAIL_ROUTE)?.[1] ?? null;
}

export function isShopRoute(pathname: string): boolean {
  return pathname === '/shop';
}
